import React from "react";
import { Navigate } from "react-router-dom";
function Protected({ children }) {
  const isProtected = localStorage.getItem("userData");

  if (!isProtected) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
export default Protected;
